"use client"

import { Head } from "@inertiajs/react"

import type { FeedShellProps } from "@/components/player/shells/jacket/use-jacket-feed"
import { RecordSleeveShell } from "@/components/player/shells/record-sleeve-shell"

export default function PlaylistPlay({
  playlist,
  tracks,
  initialPosition,
  outroSlate,
  forceOutro,
}: FeedShellProps) {
  return (
    <>
      <Head title={`${playlist.title} — Playing`} />
      <RecordSleeveShell
        playlist={playlist}
        tracks={tracks}
        initialPosition={initialPosition}
        outroSlate={outroSlate}
        forceOutro={forceOutro}
      />
    </>
  )
}
